export enum IGTMEventType {
  SubscriptionPageView = "subscription_page_view",
  SubscriptionPlanSelect = "subscription_plan_select",
  SubscriptionEmailEntry = "subscription_email_entry",
  SubscriptionEmailSubmitted = "subscription_email_submitted",
  SubscriptionCheckoutStart = "subscription_checkout_start",
  SubscriptionPaymentAttempt = "subscription_payment_attempt",
  SubscriptionPaymentCompleted = "subscription_payment_completed",
  SubscriptionPaymentFailed = "subscription_payment_failed",
  SubscriptionUpsellPopupView = "subscription_upsell_popup_view",
  SubscriptionUpsellMaybeLater = "subscription_upsell_maybe_later",
  SubscriptionUpsellRetentionPopupView = "subscription_upsell_retention_popup_view",
  SubscriptionUpsellExit = "subscription_upsell_exit",
  SubscriptionUpsellEmailEntry = "subscription_upsell_email_entry",
  SubscriptionUpsellEmailSubmitted = "subscription_upsell_email_submitted",
  SubscriptionUpsellPlanSelect = "subscription_upsell_plan_select",
  SubscriptionUpsellCheckoutStart = "subscription_upsell_checkout_start",
  SubscriptionUpsellPaymentAttempt = "subscription_upsell_payment_attempt",
  SubscriptionUpsellPaymentCompleted = "subscription_upsell_payment_completed",
  SubscriptionUpsellPaymentFailed = "subscription_upsell_payment_failed",
}
